import React from 'react'
import { faDownload, faFileContract } from '@fortawesome/pro-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { BoxV4 } from '@labrav/react-components'
import { BOX_COLLAPSIBLE_STYLE_V2 } from '../SubscriptionDetail.styles'
import { renderSubscriptionDetailHeadingIcon } from './renderSubscriptionDetailHeadingIcon'
import { SectionWrapper } from '../../../../common/components/SectionWrapper/SectionWrapper'
import {
  DetailRow,
  DetailInfo,
} from '../../../../common/components/DetailRow/DetailRow'
import { SubscriptionDetailObject } from '../../../../modules/subscription/reducer'
import { openHttpsUrl } from '../utils/subscriptionDetailHelperImports'

interface EulaDetailsSectionProps {
  subscriptionDetail: SubscriptionDetailObject
  classes: any
  cloudType: string
}

export const EulaDetailsSection: React.FC<EulaDetailsSectionProps> = ({
  subscriptionDetail,
  classes,
  cloudType,
}) => {
  if (cloudType === 'GCP' && subscriptionDetail) {
    const eulaDetails = subscriptionDetail.eulaDetails
    if (!eulaDetails) return null
    const eulaLinks = eulaDetails.eulaDocumentLink || []
    const firstLink = eulaLinks[0]

    const eulaTypeDisplay = eulaDetails.eulaType
      ? eulaDetails.eulaType.replace(/^EulaType\./, '')
      : '-'

    return (
      <div className={classes.boxWrapper}>
        <BoxV4
          variant="small"
          headingVariant="small"
          heading="EULA details"
          headingIcon={renderSubscriptionDetailHeadingIcon(classes)}
          collapsible
          collapsibleStyle={BOX_COLLAPSIBLE_STYLE_V2}
        >
          <div className={classes.sectionContentV2}>
            <DetailRow borderBottom={false}>
              <DetailInfo
                title="EULA type"
                value={
                  <div className={classes.eulaValue}>
                    <span className={classes.billingValueV2}>
                      {eulaTypeDisplay}
                    </span>
                    {firstLink && (
                      <>
                        <span className={classes.eulaSeparator}>|</span>
                        <span
                          className={classes.eulaFileName}
                          onClick={() => openHttpsUrl(firstLink)}
                          role="button"
                          tabIndex={0}
                          onKeyDown={e => {
                            if (e.key === 'Enter' || e.key === ' ') {
                              openHttpsUrl(firstLink)
                            }
                          }}
                        >
                          Download EULA
                        </span>
                      </>
                    )}
                  </div>
                }
                keyName="eulaType"
              />
            </DetailRow>
          </div>
        </BoxV4>
      </div>
    )
  }

  const handleDownloadEula = () => {
    if (subscriptionDetail?.offerDetails?.eulaFile) {
      window.open(subscriptionDetail.offerDetails.eulaFile, '_blank')
    }
  }

  const getFileName = (url?: string) => {
    if (!url) return 'EULA.pdf'
    try {
      const urlObj = new URL(url)
      const pathname = urlObj.pathname
      const fileName = pathname.split('/').pop()
      return fileName || 'EULA.pdf'
    } catch {
      return 'EULA.pdf'
    }
  }

  return (
    <SectionWrapper heading="EULA details" icon={faFileContract}>
      <div className={classes.sectionContent}>
        <DetailRow borderBottom={false}>
          <>
            <DetailInfo
              title={
                subscriptionDetail?.cppoDetails?.eulaType
                  ? 'End buyer EULA'
                  : 'EULA type'
              }
              value={
                subscriptionDetail?.offerDetails?.eulaType ||
                subscriptionDetail?.cppoDetails?.eulaType ? (
                  <div className={classes.eulaLink}>
                    <span>
                      {subscriptionDetail?.cppoDetails?.eulaType
                        ? subscriptionDetail.cppoDetails.eulaType
                        : subscriptionDetail.offerDetails.eulaType}
                    </span>
                  </div>
                ) : (
                  '-'
                )
              }
              keyName="eulaType"
            />
            {subscriptionDetail?.offerDetails?.eulaFile && (
              <DetailInfo
                title={'ISV EULA for buyer'}
                value={
                  <div className={classes.eulaDownloadSection}>
                    <span
                      className={classes.eulaFileName}
                      onClick={handleDownloadEula}
                      role="button"
                      tabIndex={0}
                      onKeyDown={e => {
                        if (e.key === 'Enter' || e.key === ' ') {
                          handleDownloadEula()
                        }
                      }}
                    >
                      {getFileName(subscriptionDetail.offerDetails.eulaFile)}
                    </span>
                    <FontAwesomeIcon
                      icon={faDownload}
                      className={classes.downloadIcon}
                      onClick={handleDownloadEula}
                    />
                  </div>
                }
                keyName="eulaFile"
              />
            )}
          </>
        </DetailRow>
      </div>
    </SectionWrapper>
  )
}
